module.exports = __webpack_public_path__ + "images/category_lp/pc/lp-pc-selection_bg_134aa768ce221ac48b6d61d2a07eeb48.png";